/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import {
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
  Table,
  Container,
  Card
} from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import api from '../../config/AxiosInstance'
import { Formik } from 'formik'
import { PlusCircle, Search, Trash2 } from 'lucide-react'
import { CreateStockAdjustmentSchema } from '../../utils/validationSchema'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import toast, { Toaster } from 'react-hot-toast'
import { exportToExcel } from 'react-json-to-excel'
import RowEmpty from '../../components/atoms/RowEmpty'
import { Loader } from 'react-bootstrap-typeahead'
import TablePagination from '../../components/atoms/Table/TablePagination'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const valueStyle = {
  fontSize: '0.9rem',
  fontWeight: '500',
  color: '#212529',
  minHeight: '24px'
}
function CreateStockAdjustment() {
  const fileInputRef = useRef(null)
  const { state } = useLocation()
  const navigate = useNavigate()
  const debounceTimeout = useRef(null)
  const abortControllerRef = useRef(null)
  const [selectedItem, setSelectedItem] = useState([])
  const [searchItem, setSearchItem] = useState('')
  const [dataItems, setDataItems] = useState({
    data: [],
    isFetch: false,
    metaData: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })
  const [payload, setPayload] = useState({
    items: []
  })
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState({
    download: false,
    import: false,
    item: false,
    submit: false
  })
  const [resultImport, setResultImport] = useState({
    success: [],
    failed: []
  })
  const [visible, setVisible] = useState({
    import: false,
    cancel: false,
    uploadSuccess: false,
    create: false,
    item: false
  })

  const handleShow = (name) => {
    setVisible({ ...visible, [name]: true })
  }

  const handleClose = async (data = undefined) => {
    // read property true to false
    const propertyVisible = Object.keys(visible).find(
      (key) => visible[key] === true
    )
    if (propertyVisible) {
      setVisible({ ...visible, [propertyVisible]: false })
    }
    // read data slot ite id selected item
    let newSelectedItem = []
    if (Array.isArray(data) && data.length > 0) {
      const slotItemIdPayloadId = data.map((item) => item.slot_item_id)
      newSelectedItem =
        selectedItem?.filter((item) =>
          slotItemIdPayloadId.includes(item.slot_item_id)
        ) ?? []
    } else {
      const slotItemIdPayloadId =
        payload.items?.map((item) => item.slot_item_id) ?? []
      newSelectedItem =
        selectedItem?.filter((item) =>
          slotItemIdPayloadId.includes(item.slot_item_id)
        ) ?? []
    }

    if (searchItem !== '') {
      setSearchItem('')
    }
    setSelectedItem(newSelectedItem)
    setDataItems({
      data: [],
      isFetch: false,
      metaData: {
        per_page: 10,
        current_page: 1,
        total_row: 0,
        total_page: 0
      }
    })
  }

  const getTitleModal = () => {
    const propertyVisible = Object.keys(visible).find(
      (key) => visible[key] === true
    )
    if (propertyVisible === 'import') {
      return 'Import Item'
    } else if (propertyVisible === 'uploadSuccess') {
      return 'Upload Completed'
    } else if (propertyVisible === 'item') {
      return 'Select Item'
    }
    return ''
  }

  const handleRemoveItem = (e, id) => {
    e.stopPropagation()
    setPayload((prev) => ({
      ...prev,
      items: prev.items.filter((item) => item.id !== id)
    }))
    // check on selected item already id item specific or not
    const itemSelectedItem = selectedItem.find((item) => item.id === id)
    setSelectedItem((prev) =>
      prev.filter((item) => item.id !== itemSelectedItem?.id)
    )
  }

  const isVas = state?.type === 'vas' || state?.is_vas

  const handleChangeInputItem = (name, id, value) => {
    setPayload((prev) => ({
      ...prev,
      items: prev.items.map((item) => {
        if (item.id === id) {
          const factor = parseFloat(
            String(item?.convertion_factor_pack || 1).replace(',', '.')
          )
          const valClean = String(value ?? '').replace(',', '.')

          if (isVas && item.from_add_item && item.initial_pack !== undefined) {
            const maxPack = Number(item.initial_pack)
            const maxQty = maxPack * factor

            if (name === 'adjustment_pack') {
              if (valClean !== '' && valClean !== '-' && valClean !== '.') {
                const num = parseFloat(valClean)
                if (!isNaN(num)) {
                  if (num > maxPack) {
                    toast.error(`Maksimal qty kemasan adalah ${maxPack}`, {
                      id: `max-pack-${id}`,
                      position: 'top-right'
                    })
                    value = String(maxPack)
                  } else if (num < 0) {
                    value = '0'
                  }
                }
              }
            } else if (name === 'adjustment_qty') {
              if (valClean !== '' && valClean !== '-' && valClean !== '.') {
                const num = parseFloat(valClean)
                if (!isNaN(num)) {
                  if (num > maxQty) {
                    toast.error(
                      `Maksimal base qty adalah ${maxQty.toFixed(2)}`,
                      {
                        id: `max-qty-${id}`,
                        position: 'top-right'
                      }
                    )
                    value = String(maxQty.toFixed(2))
                  } else if (num < 0) {
                    value = '0'
                  }
                }
              }
            }
          }

          const updatedItem = {
            ...item,
            [name]: value
          }
          const finalValClean = String(value ?? '').replace(',', '.')
          if (name === 'adjustment_pack') {
            if (
              finalValClean === '' ||
              finalValClean === '-' ||
              finalValClean === '.'
            ) {
              updatedItem.adjustment_qty = value
            } else {
              const pack = parseFloat(finalValClean)
              if (!isNaN(pack)) {
                updatedItem.adjustment_qty = String((pack * factor).toFixed(2))
              }
            }
          } else if (name === 'adjustment_qty') {
            if (
              finalValClean === '' ||
              finalValClean === '-' ||
              finalValClean === '.'
            ) {
              updatedItem.adjustment_pack = value
            } else {
              const qty = parseFloat(finalValClean)
              if (!isNaN(qty)) {
                updatedItem.adjustment_pack = String(
                  factor > 0 ? (qty / factor).toFixed(4) : 0
                )
              }
            }
          }
          return updatedItem
        }
        return item
      })
    }))
  }

  const renderAction = (data) => (
    <div key={data.id}>
      <button
        type="button"
        className="btn btn-danger"
        onClick={(e) => handleRemoveItem(e, data.id)}
      >
        <Trash2 size={14} />
      </button>
    </div>
  )

  const renderInputQty = (data) => {
    const factor = parseFloat(
      String(data?.convertion_factor_pack || 1).replace(',', '.')
    )
    const maxQty =
      isVas && data.from_add_item && data.initial_pack !== undefined
        ? Number((Number(data.initial_pack) * factor).toFixed(2))
        : undefined

    return (
      <div
        key={`${data.id}-qty`}
        className="d-flex flex-column align-items-end"
        style={{ minWidth: '135px' }}
      >
        {!state?.event_report_id ? (
          <InputGroup size="sm" style={{ width: '135px' }}>
            <Form.Control
              type="number"
              placeholder="0"
              min="0"
              max={maxQty}
              value={data.adjustment_qty ?? ''}
              onChange={(e) =>
                handleChangeInputItem('adjustment_qty', data.id, e.target.value)
              }
              className="text-end pe-2"
              style={{ fontSize: '13px' }}
            />
            <InputGroup.Text
              className="bg-light text-muted px-2"
              style={{
                fontSize: '12px',
                fontWeight: '500',
                maxWidth: '65px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
              title={data.uom_qty || 'Kg'}
            >
              {data.uom_qty || 'Kg'}
            </InputGroup.Text>
          </InputGroup>
        ) : (
          <div className="d-flex align-items-center justify-content-end text-end">
            <span>{data.adjustment_qty ?? '0'}</span>
            <span className="ms-1 text-muted" style={{ fontSize: '12px' }}>
              {data.uom_qty || 'Kg'}
            </span>
          </div>
        )}
        {isVas && data.from_add_item && data.initial_pack !== undefined && (
          <small
            className="text-muted mt-1 text-end"
            style={{ fontSize: '11px', whiteSpace: 'nowrap' }}
          >
            Max: {maxQty} {data.uom_qty || 'Kg'}
          </small>
        )}
      </div>
    )
  }

  const renderInputPack = (data) => {
    const maxPack =
      isVas && data.from_add_item && data.initial_pack !== undefined
        ? Number(data.initial_pack)
        : undefined

    return (
      <div
        key={`${data.id}-pack`}
        className="d-flex flex-column align-items-end"
        style={{ minWidth: '150px' }}
      >
        {!state?.event_report_id ? (
          <InputGroup size="sm" style={{ width: '150px' }}>
            <Form.Control
              type="number"
              placeholder="0"
              min="0"
              max={maxPack}
              value={data.adjustment_pack ?? ''}
              onChange={(e) =>
                handleChangeInputItem(
                  'adjustment_pack',
                  data.id,
                  e.target.value
                )
              }
              className="text-end pe-2"
              style={{ fontSize: '13px' }}
            />
            <InputGroup.Text
              className="bg-light text-muted px-2"
              style={{
                fontSize: '12px',
                fontWeight: '500',
                maxWidth: '85px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
              title={data.uom_pack || '-'}
            >
              {data.uom_pack || '-'}
            </InputGroup.Text>
          </InputGroup>
        ) : (
          <div className="d-flex align-items-center justify-content-end text-end">
            <span>{data.adjustment_pack ?? '0'}</span>
            <span className="ms-1 text-muted" style={{ fontSize: '12px' }}>
              {data.uom_pack || '-'}
            </span>
          </div>
        )}
        {isVas && data.from_add_item && data.initial_pack !== undefined && (
          <small
            className="text-muted mt-1 text-end"
            style={{ fontSize: '11px', whiteSpace: 'nowrap' }}
          >
            Max: {maxPack} {data.uom_pack || ''}
          </small>
        )}
      </div>
    )
  }

  const columns = !state?.event_report_id
    ? [
        { key: 'row_number', label: 'No' },
        {
          key: 'item_code',
          label: 'Item Code - Name',
          component: (data) =>
            `${data?.item_code || '-'} - ${data?.item_name || '-'}`
        },
        { key: 'batch', label: 'Batch', className: 'text-end align-end' },
        { key: 'slot', label: 'Slot', className: 'text-end align-end' },
        { key: 'palet', label: 'Palet', className: 'text-end align-end' },
        {
          key: 'adjustment_qty',
          label: 'Base Qty UOM',
          className: 'text-end align-end text-nowrap',
          component: (data) => renderInputQty(data)
        },
        {
          key: 'adjustment_pack',
          label: 'Qty Kemasan',
          className: 'text-end align-end text-nowrap',
          component: (data) => renderInputPack(data)
        },
        {
          key: 'action',
          label: 'Action',
          component: (data) => renderAction(data),
          className: 'text-end align-end'
        }
      ]
    : [
        { key: 'row_number', label: 'No' },
        {
          key: 'item_code',
          label: 'Item Code - Name',
          component: (data) =>
            `${data?.item_code || '-'} - ${data?.item_name || '-'}`
        },
        { key: 'batch', label: 'Batch', className: 'text-end align-end' },
        { key: 'slot', label: 'Slot', className: 'text-end align-end' },
        { key: 'palet', label: 'Palet', className: 'text-end align-end' },
        {
          key: 'adjustment_qty',
          label: 'Base Qty UOM',
          className: 'text-end align-end text-nowrap',
          component: (data) => renderInputQty(data)
        },
        {
          key: 'adjustment_pack',
          label: 'Qty Kemasan',
          className: 'text-end align-end text-nowrap',
          component: (data) => renderInputPack(data)
        }
      ]

  const columnAddItems = [
    { key: 'checkbox', label: 'checkbox' },
    {
      key: 'item_name',
      label: 'Item Code - Name',
      component: (data) =>
        `${data?.item_code || '-'} - ${data?.item_name || '-'}`
    },
    { key: 'batch', label: 'Batch', className: 'text-end align-end' },
    {
      key: 'total_pack',
      label: 'Qty Kemasan',
      className: 'text-end align-end',
      component: (data) => `${data?.total_pack || '0'} ${data?.uom_pack || ''}`
    },
    {
      key: 'total_qty',
      label: 'Base Qty UOM',
      className: 'text-end align-end',
      component: (data) => `${data?.total_qty || '0'} ${data?.uom_qty || ''}`
    },
    { key: 'slot', label: 'Slot', className: 'text-end align-end' },
    { key: 'palet_id', label: 'Palet', className: 'text-end align-end' }
  ]

  const handleDownloadTemplate = async () => {
    try {
      setLoading((prev) => ({ ...prev, download: true }))
      const res = await api.post(
        '/stock-adjustment/download-template',
        {}, // Empty object for the request body
        { responseType: 'arraybuffer' } // Move responseType here
      )
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'download-template-stock-adjustment.xlsx')
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } else {
        throw new Error('Something went wrong')
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prev) => ({ ...prev, download: false }))
    }
  }

  const handleChangeImportFile = (e) => {
    if (e.target.files.length === 0) {
      return
    }
    const file = e.target.files[0]
    setFile(file)
  }

  const handleDownloadTemplateItemError = async () => {
    try {
      setLoading((prev) => ({ ...prev, download: true }))
      if (!resultImport.failed.length) {
        throw new Error('No data to download')
      }
      exportToExcel(resultImport.failed, 'template_adjustment_error')
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setTimeout(() => {
        setLoading((prev) => ({ ...prev, download: false }))
      }, 1000)
    }
  }

  const handleImportFile = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, import: true }))
      const formImport = new FormData()
      if (!file) {
        const errMsg = 'File attachment is required'
        throw new Error(errMsg)
      }
      formImport.append('file', file)
      formImport.append('warehouse_id', state.warehouse_id)
      formImport.append('is_packing', state?.is_packing || false)
      if (isVas) {
        formImport.append('type', 'vas')
      }
      const res = await api.post('stock-adjustment/import-data', formImport, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const { status, data } = res
      if (status === 200) {
        setResultImport({
          success: data.data.success,
          failed: data.data.failed
        })
        let newItems = []

        const isItemMatch = (itemA, itemB) => {
          if (isVas) {
            return (
              itemA.item_code === itemB.item_code &&
              itemA.batch === itemB.batch &&
              itemA.palet === itemB.palet
            )
          }
          if (state?.is_packing) {
            return itemA.item_code === itemB.item_code
          }
          return (
            itemA.item_code === itemB.item_code &&
            itemA.batch === itemB.batch &&
            itemA.palet === itemB.palet &&
            itemA.slot === itemB.slot
          )
        }

        if (!payload.items.length) {
          newItems = data.data.success.map((item) => ({
            ...item,
            id: item.slot_item_id ?? Math.random().toString().substring(2, 14)
          }))
        } else {
          // read data item exist
          const itemExists = payload.items
            .filter((item) =>
              data.data.success.some((i) => isItemMatch(i, item))
            )
            .map((result) => {
              const resultItemExist = data?.data?.success.find((itemSuccess) =>
                isItemMatch(itemSuccess, result)
              )
              const newPack =
                Number(result.adjustment_pack) +
                Number(resultItemExist?.adjustment_pack || 0)
              const factor = parseFloat(result?.convertion_factor_pack || 1)
              return {
                ...result,
                adjustment_pack: newPack,
                adjustment_qty: String((newPack * factor).toFixed(2))
              }
            })
          // read data item not exist
          const itemNotExists = [
            ...payload?.items?.filter(
              (item) => !data.data.success.some((i) => isItemMatch(i, item))
            ),
            ...(data?.data?.success?.filter(
              (item) => !payload?.items?.some((i) => isItemMatch(i, item))
            ) || [])
          ]
          newItems = [...itemExists, ...itemNotExists]
        }
        setPayload((prevPayload) => ({
          ...prevPayload,
          items: newItems
        }))
        if (data.data.failed.length > 0) {
          setVisible({ ...visible, import: false, uploadSuccess: true })
        } else {
          setVisible({ ...visible, import: false })
        }
        if (fileInputRef.current) {
          fileInputRef.current.value = ''
        }
      } else {
        throw new Error('Something went wrong')
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, import: false }))
    }
  }

  const getDataItems = async () => {
    try {
      setLoading((prevLoading) => ({ ...prevLoading, item: true }))
      const params = {
        warehouse_id: state?.warehouse_id || '',
        per_page: dataItems.metaData.per_page || 10,
        page: dataItems.metaData.current_page || 1,
        q: searchItem || '',
        is_packing: state?.is_packing || null,
        ...(isVas ? { type: 'vas' } : {})
      }
      const response = await api.get('/stock-adjustment/all-items', { params })
      const { data, metadata } = response.data
      setDataItems((prevDataItems) => ({
        ...prevDataItems,
        data: data.map((item) => ({
          ...item,
          id: item.slot_item_id ?? Math.random().toString().substring(2, 14)
        })),
        isFetch: true,
        metaData: metadata
      }))
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({ ...prevLoading, item: false }))
    }
  }

  const handleChangeCheckbox = (id) => {
    if (!id) {
      if (
        !selectedItem.length ||
        selectedItem.length !== dataItems.data.length
      ) {
        setSelectedItem(dataItems.data)
      } else {
        setSelectedItem([])
      }
    } else {
      const dataSelectedItem = dataItems.data.find(
        (item) => item.slot_item_id === id
      )
      setSelectedItem((prevSelectedItem) => {
        if (prevSelectedItem.find((item) => item.slot_item_id === id)) {
          return prevSelectedItem.filter((item) => item.slot_item_id !== id)
        } else {
          return [...prevSelectedItem, dataSelectedItem]
        }
      })
    }
  }

  const handleSubmit = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        submit: true
      }))
      const items = payload?.items?.map((item) => {
        let packStr = String(item?.adjustment_pack ?? '0').replace(',', '.')
        let pack = Number(packStr)
        let adjustment_pack = isNaN(pack) ? 0 : pack

        let qtyStr = String(item?.adjustment_qty ?? '0').replace(',', '.')
        let qty = Number(qtyStr)
        let adjustment_qty = isNaN(qty) ? 0 : qty

        return {
          slot_item_id: item.slot_item_id ?? null,
          batch: item.batch,
          slot: item.slot,
          palet_id: item.palet,
          item_code: item.item_code,
          adjustment_pack,
          adjustment_qty,
          status_slot: item.status_slot ?? null
        }
      })

      const formData = new FormData()
      formData.append('warehouse_id', payload.payload?.warehouse_id)
      formData.append('note', payload.payload?.note)
      formData.append('series_number', 'MV.YY./.MM./B.####')
      formData.append('is_packing', state?.is_packing || false)
      if (isVas) {
        formData.append('type', 'vas')
      }
      formData.append('items', JSON.stringify(items))

      if (state?.event_report_id) {
        formData.append('event_report_id', state?.event_report_id)
      }

      if (file) {
        formData.append('file', file)
      }

      const res = await api.post('/stock-adjustment/new-ticket', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const { status } = res
      if (Number(status) === 200) {
        toast.success('Stock Adjustment Created!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        navigate('/stock-adjustment', {
          state: {
            warehouse_id: state.warehouse_id
          }
        })
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        submit: false
      }))
    }
  }

  const handleSubmitAddItem = async () => {
    // override data selected item for property same with payload items
    const tmpSelectedAddItems = selectedItem.map((itemMap) => {
      const totalPack = Number(itemMap.total_pack ?? 0)
      const factor = parseFloat(
        String(itemMap?.convertion_factor_pack || 1).replace(',', '.')
      )
      return {
        ...itemMap,
        slot_item_id: itemMap.slot_item_id,
        item_code: itemMap.item_code,
        item_name: itemMap.item_name,
        batch: itemMap.batch,
        palet: itemMap.palet_id,
        slot: itemMap.slot,
        total_pack: itemMap.total_pack,
        initial_pack: isVas ? totalPack : undefined,
        from_add_item: isVas ? true : false,
        adjustment_pack: isVas ? totalPack : 0,
        adjustment_qty: isVas ? String((totalPack * factor).toFixed(2)) : 0,
        id: itemMap.slot_item_id ?? Math.random().toString().substring(2, 14)
      }
    })
    // new data item
    const isItemMatch = (itemA, itemB) => {
      if (isVas) {
        return (
          itemA.item_code === itemB.item_code &&
          itemA.batch === itemB.batch &&
          itemA.palet === itemB.palet
        )
      }
      if (state?.is_packing) {
        return itemA.item_code === itemB.item_code
      }
      return (
        itemA.item_code === itemB.item_code &&
        itemA.batch === itemB.batch &&
        itemA.palet === itemB.palet &&
        itemA.slot === itemB.slot
      )
    }

    const newDataItems = [
      ...payload.items,
      ...tmpSelectedAddItems.filter(
        (item) => !payload.items.some((i) => isItemMatch(i, item))
      )
    ]
    setPayload((prevPayload) => ({
      ...prevPayload,
      items: newDataItems
    }))
    await handleClose(newDataItems)
  }

  const handleOnChangeMeta = (e) => {
    setDataItems((prevDataItems) => ({
      ...prevDataItems,
      metaData: {
        ...prevDataItems.metaData,
        per_page: parseInt(e.target.value, 10),
        current_page: 1
      }
    }))
    // check selected item already in payload items or not
    const tmpSelectedAddItems =
      selectedItem?.map((itemMap) => ({
        slot_item_id: itemMap.slot_item_id,
        item_code: itemMap.item_code,
        batch: itemMap.batch,
        palet: itemMap.palet_id,
        slot: itemMap.slot,
        adjustment_pack: 0,
        adjustment_qty: 0
      })) || []
    const tmpSelectedItemLength = payload.items.filter((item) =>
      tmpSelectedAddItems.find((i) => i.slot_item_id === item.slot_item_id)
    )?.length
    if (selectedItem.length > 0 && !tmpSelectedItemLength) {
      setSelectedItem([])
    }
  }

  const handlePageChange = (data) => {
    setDataItems((prevDataItems) => ({
      ...prevDataItems,
      metaData: { ...prevDataItems.metaData, current_page: data.selected + 1 }
    }))
    // check selected item already in payload items or not
    const tmpSelectedAddItems =
      selectedItem?.map((itemMap) => ({
        slot_item_id: itemMap.slot_item_id,
        item_code: itemMap.item_code,
        batch: itemMap.batch,
        palet: itemMap.palet_id,
        slot: itemMap.slot,
        adjustment_pack: 0,
        adjustment_qty: 0
      })) || []
    const tmpSelectedItemLength = payload.items.filter((item) =>
      tmpSelectedAddItems.find((i) => i.slot_item_id === item.slot_item_id)
    )?.length
    if (selectedItem.length > 0 && !tmpSelectedItemLength) {
      setSelectedItem([])
    }
    window.scrollTo(0, 0)
  }
  const checkDisableButton = useMemo(() => {
    if (!payload?.items || payload?.items?.length === 0) {
      return true
    }
    return (
      payload?.items?.some((item) => {
        const packStr = String(item?.adjustment_pack ?? '').trim()
        const qtyStr = String(item?.adjustment_qty ?? '').trim()

        if (
          packStr === '' ||
          packStr === '-' ||
          packStr === '.' ||
          packStr === ',' ||
          qtyStr === '' ||
          qtyStr === '-' ||
          qtyStr === '.' ||
          qtyStr === ','
        ) {
          return true
        }

        const packNum = Number(packStr.replace(',', '.'))
        const qtyNum = Number(qtyStr.replace(',', '.'))

        if (isNaN(packNum) || isNaN(qtyNum)) {
          return true
        }

        if (isVas && item.from_add_item && item.initial_pack !== undefined) {
          if (packNum > Number(item.initial_pack) || packNum < 0) {
            return true
          }
        }

        return false
      }) || loading.submit
    )
  }, [payload?.items, loading.submit, isVas])
  const fetchDataItemFromBA = async () => {
    try {
      const params = {
        opname_id: state?.opname_id || undefined
      }
      const response = await api.get('/stock-adjustment/import-ba', { params })
      const { data } = response.data
      setPayload((prevPayload) => ({
        ...prevPayload,
        items: data?.success || []
      }))
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const handleSearch = (value) => {
    setSearchItem(value)
    setDataItems((prevDataItems) => ({
      ...prevDataItems,
      metaData: { ...prevDataItems.metaData, current_page: 1 }
    }))
  }
  const debouncedFetch = useCallback(() => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current)

    debounceTimeout.current = setTimeout(() => {
      // Cancel the previous API request
      if (abortControllerRef.current) abortControllerRef.current.abort()

      // Create a new AbortController
      const controller = new AbortController()
      abortControllerRef.current = controller

      if (visible.item) {
        getDataItems({ signal: controller.signal }).catch((err) => {
          if (err.name !== 'AbortError') console.error('API Error:', err)
        })
      }
    }, 1000)
  }, [
    visible.item,
    searchItem,
    dataItems.metaData.current_page,
    dataItems.metaData.per_page
  ])
  useEffect(() => {
    debouncedFetch()
    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
      if (abortControllerRef.current) abortControllerRef.current.abort() // Cancel on unmount
    }
  }, [debouncedFetch])

  useEffect(() => {
    if (state?.event_report_id) {
      fetchDataItemFromBA()
    }
  }, [state?.event_report_id])
  return (
    <Container fluid className="px-4 mb-5">
      <Row className="mb-4 align-items-center">
        <Col>
          <div className="d-flex flex-column justify-content-start">
            <h3 style={headerTitleStyle}>Create Stock Adjustment</h3>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb fs-6 mb-0">
                <li className="breadcrumb-item">
                  <Button
                    variant="transparent"
                    className="p-0"
                    onClick={() => handleShow('cancel')}
                  >
                    <span
                      className="text-muted fw-bold text-uppercase"
                      style={{ fontSize: '12px' }}
                    >
                      stock adjustment
                    </span>
                  </Button>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <span
                    className="text-uppercase fw-bold text-dark"
                    style={{ fontSize: '12px' }}
                  >
                    create
                  </span>
                </li>
              </ol>
            </nav>
          </div>
        </Col>
      </Row>

      <Formik
        initialValues={{
          warehouse_id: state.warehouse_id,
          note: state?.code || ''
        }}
        validateOnChange={true}
        validationSchema={CreateStockAdjustmentSchema}
        onSubmit={(values) => {
          setPayload((prevPayload) => ({
            ...prevPayload,
            payload: values
          }))
          handleShow('create')
        }}
      >
        {({
          handleBlur,
          handleSubmit,
          handleChange,
          values,
          errors,
          touched,
          isValid,
          dirty
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Card style={cardFilterStyle}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>WAREHOUSE</Form.Label>
                      <div style={valueStyle}>
                        {state.warehouse_name || state.warehouse || '-'}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>
                        NOTE <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="note"
                        value={values.note}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Note..."
                        disabled={state?.event_report_id}
                        isInvalid={touched.note && !!errors.note}
                        style={{
                          ...valueStyle,
                          border: '1px solid #dee2e6',
                          borderRadius: '8px',
                          padding: '0.5rem'
                        }}
                      />
                      {touched.note && errors.note && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="d-block"
                        >
                          {errors.note}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Card>

              <Card style={cardFilterStyle}>
                {!state.event_report_id && (
                  <div className="d-flex justify-content-end mb-3 gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-warning"
                      onClick={() => handleShow('import')}
                    >
                      <div className="d-flex flex-row gap-2 align-items-center">
                        <PlusCircle size={16} />
                        <span>Import</span>
                      </div>
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary-blue"
                      onClick={() => handleShow('item')}
                    >
                      <span>Add Item</span>
                    </button>
                  </div>
                )}

                <Table
                  responsive
                  hover
                  className="mb-0"
                  style={{ fontSize: '14px' }}
                >
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {columns.map((column) => (
                        <th
                          className={`p-2 align-middle ${
                            column.className ?? ''
                          }`}
                          key={column.key}
                          style={tableHeaderStyle}
                        >
                          {column.key !== 'checkbox' && (
                            <span>{column.label}</span>
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {!payload.items.length && (
                      <RowEmpty colSpan={columns.length} />
                    )}
                    {payload.items.length > 0 &&
                      payload.items.map((item, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: '1px solid #f0f0f0' }}
                        >
                          {columns.map((column) => (
                            <td
                              key={column.key}
                              className={`p-2 align-middle ${
                                column.className ?? ''
                              }`}
                            >
                              {column.key === 'row_number' && index + 1}
                              {column.component && column.component(item)}
                              {column.key !== 'action' &&
                                !column.component &&
                                !column.key.includes('checkbox') &&
                                !column.key.includes('row_number') &&
                                (item[column.key] ?? '-')}
                            </td>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Card>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <Button
                  type="button"
                  variant="light"
                  className="text-danger fw-bold border"
                  style={{ padding: '0.5rem 1.5rem', borderRadius: '8px' }}
                  onClick={() => handleShow('cancel')}
                >
                  Cancel
                </Button>
                <Button
                  className={`${
                    !(state?.event_report_id
                      ? loading.submit
                        ? true
                        : false
                      : !isValid || checkDisableButton)
                      ? 'btn-primary-orange'
                      : 'btn-secondary opacity-25'
                  }`}
                  style={{ padding: '0.5rem 1.5rem', borderRadius: '8px' }}
                  type="submit"
                  disabled={
                    state?.event_report_id
                      ? loading.submit
                        ? true
                        : false
                      : !isValid || checkDisableButton
                  }
                >
                  Submit
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>

      <ModalStockAdjustment
        show={Object.values(visible).includes(true)}
        onHide={handleClose}
        title={getTitleModal()}
        size={visible.item ? 'xl' : 'md'}
        backdrop="static"
      >
        <div>
          {visible.uploadSuccess && (
            <div className="p-2 mt-3">
              <div className="mt-2">
                <p>
                  <span className="fw-bold">
                    {resultImport?.failed?.length || 0}
                  </span>{' '}
                  data failed to upload. Download the data{' '}
                  <button
                    style={{
                      color: `${
                        loading.download
                          ? 'var(--primary-grey)'
                          : 'var(--primary-orange)'
                      }`,
                      opacity: `${loading.download ? '0.25' : '1'}`
                    }}
                    className="cursor-pointer download-template-stock-adjustment fw-bold"
                    disabled={loading.download}
                    onClick={() => handleDownloadTemplateItemError()}
                  >
                    {loading.download ? 'Downloading...' : 'here'}
                  </button>
                </p>
              </div>
            </div>
          )}
          {visible.import && (
            <div className="p-2 mt-3">
              <div className="mt-2">
                <input
                  type="file"
                  className="d-none"
                  ref={fileInputRef}
                  accept=".xlsx, .csv"
                  onChange={(e) => handleChangeImportFile(e)}
                />
                <p>
                  Make sure the uploaded file is in the correct format. You can
                  download the correct format{' '}
                  <button
                    style={{
                      color: `${
                        loading.download
                          ? 'var(--primary-grey)'
                          : 'var(--primary-orange)'
                      }`,
                      opacity: `${loading.download ? '0.25' : '1'}`
                    }}
                    className="cursor-pointer download-template-stock-adjustment fw-bold"
                    disabled={loading.download}
                    onClick={() => handleDownloadTemplate()}
                  >
                    {loading.download ? 'Downloading...' : 'here'}
                  </button>
                </p>
              </div>
              <Row>
                <div className="d-flex gap-3">
                  <button
                    className="btn btn-outline-dark"
                    onClick={() => fileInputRef?.current?.click()}
                  >
                    <span>Select File</span>
                  </button>
                  <div className="d-flex flex-column justify-content-center align-items-center h-100">
                    <span
                      className="fw-bold text-muted"
                      style={{ fontSize: '12px' }}
                    >
                      {file ? file?.name : 'Select .xlsx or .csv file'}
                    </span>
                  </div>
                </div>
              </Row>
              <Modal.Footer className="mt-4">
                <div className="d-flex flex-column align-items-end justify-content-end h-100 mt-3">
                  <div className="d-flex gap-2">
                    <Button
                      variant="transparent"
                      onClick={() => {
                        handleClose()
                        if (file) {
                          setFile(null)
                        }
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      className={`${
                        file && !loading.import
                          ? 'btn-primary-orange'
                          : 'btn-secondary opacity-25'
                      }`}
                      disabled={!file || loading.import}
                      onClick={handleImportFile}
                    >
                      Import
                    </Button>
                  </div>
                </div>
              </Modal.Footer>
            </div>
          )}
          {visible.item && (
            <Row
              className="mt-3"
              style={{ overflowY: 'auto', maxHeight: '70vh' }}
            >
              <div className="d-flex flex-row gap-2 my-2 justify-content-end">
                <InputGroup className="mb-3" style={{ width: '40%' }}>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <InputGroup.Text>
                    <Search size={16} />
                  </InputGroup.Text>
                </InputGroup>
                <div>
                  <Button
                    className={`${
                      selectedItem.length > 0
                        ? 'btn-primary-orange'
                        : 'btn-secondary opacity-25'
                    }`}
                    disabled={!selectedItem.length}
                    onClick={handleSubmitAddItem}
                  >
                    Submit
                  </Button>
                </div>
              </div>
              <Table
                responsive
                hover
                className="shadow-sm mb-5 bg-white rounded"
                size="sm"
                style={{ fontSize: '14px' }}
              >
                <thead className="table-secondary">
                  <tr>
                    {columnAddItems.map((columnAddItem) => (
                      <th className="align-middle p-2" key={columnAddItem.key}>
                        {columnAddItem.key === 'checkbox' && (
                          <input
                            type="checkbox"
                            className="staging-area form-check-input"
                            checked={
                              dataItems.data?.length !== 0 &&
                              dataItems.data.length === selectedItem.length
                            }
                            disabled={!dataItems.data?.length}
                            onChange={() => handleChangeCheckbox()}
                            role="button"
                          />
                        )}
                        {columnAddItem.key !== 'checkbox' && (
                          <span>{columnAddItem.label}</span>
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(loading.item || !dataItems.isFetch) && (
                    <tr>
                      <td
                        colSpan={columnAddItems.length}
                        className="p-3 text-center"
                      >
                        <Loader />
                      </td>
                    </tr>
                  )}
                  {!loading.item &&
                    !dataItems.data?.length &&
                    dataItems.isFetch && (
                      <RowEmpty colSpan={columnAddItems.length} />
                    )}
                  {!loading.item &&
                    dataItems.data?.length > 0 &&
                    dataItems.isFetch &&
                    dataItems.data?.map((item, index) => (
                      <tr key={index}>
                        {columnAddItems.map((column) => (
                          <td key={column.key} className="p-2 align-middle">
                            {column.key === 'checkbox' && (
                              <input
                                type="checkbox"
                                className="add-item-adjustment form-check-input"
                                value={item?.slot_item_id}
                                checked={
                                  selectedItem.find(
                                    (selectId) =>
                                      selectId?.slot_item_id ===
                                      item?.slot_item_id
                                  ) ||
                                  payload.items.find(
                                    (payloadItem) =>
                                      payloadItem?.slot_item_id ===
                                      item?.slot_item_id
                                  )
                                    ? true
                                    : false
                                }
                                disabled={payload.items.find(
                                  (payloadItem) =>
                                    payloadItem?.slot_item_id ===
                                    item?.slot_item_id
                                )}
                                onChange={() =>
                                  handleChangeCheckbox(item?.slot_item_id)
                                }
                                role="button"
                              />
                            )}
                            {column.component && column.component(item)}
                            {column.key !== 'action' &&
                              !column.component &&
                              !column.key.includes('checkbox') &&
                              (item[column.key] ?? '-')}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td className="p-3" colSpan={columnAddItems.length}>
                      <TablePagination
                        meta={dataItems.metaData}
                        handlePageChange={handlePageChange}
                        handleOnChangeMeta={handleOnChangeMeta}
                      />
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </Row>
          )}
          {(visible.cancel || visible.create) && (
            <div className="p-2 mt-3 text-center">
              <div className="d-flex justify-content-center">
                <svg
                  width="181"
                  height="180"
                  viewBox="0 0 181 180"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                    fill="#828282"
                  />
                  <path
                    d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                    fill="#828282"
                  />
                </svg>
              </div>
              <div className="my-3">
                {visible.cancel && (
                  <>
                    <h6>Cancel?</h6>
                    <p>All data will be deleted, cancel creating ticket?</p>
                  </>
                )}
                {visible.create && (
                  <>
                    <h6>Create?</h6>
                    <p>Make sure all data is correct!</p>
                  </>
                )}
              </div>
              <Modal.Footer className="mt-4">
                <div className="d-flex flex-column align-items-end justify-content-end h-100 mt-3">
                  <div className="d-flex gap-2">
                    <Button
                      variant="transparent"
                      onClick={() => {
                        handleClose()
                        if (visible.create) {
                          setPayload({
                            items: payload.items
                          })
                        }
                      }}
                    >
                      {visible.cancel && 'Continue Creating'}
                      {visible.create && 'Cancel'}
                    </Button>
                    {visible.cancel && (
                      <Button
                        className="btn-primary-orange"
                        onClick={() => {
                          navigate('/stock-adjustment', {
                            state: {
                              warehouse_id: state?.warehouse_id || ''
                            }
                          })
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                    {visible.create && (
                      <Button
                        className={`${
                          loading.submit
                            ? 'btn-secondary opacity-25'
                            : 'btn-primary-orange'
                        }`}
                        disabled={loading.submit}
                        onClick={() => handleSubmit()}
                      >
                        Create Ticket
                      </Button>
                    )}
                  </div>
                </div>
              </Modal.Footer>
            </div>
          )}
        </div>
      </ModalStockAdjustment>
      <Toaster />
    </Container>
  )
}

export default CreateStockAdjustment
